import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeMount } from 'vue';
import { Toast } from 'vant';
import { useRoute } from 'vue-router';
import { getRiskToken, getToken } from '../data-source/api';
import { BASE_PATH, BASE_DOMAIN } from '@/config';

import qs from 'qs';
import { FaceAuthType } from '../types';


const __default__ = {
  name: 'face-auth-agreement'
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();

onBeforeMount(async () => {
  console.log('人脸');
  Toast.loading('加载中');
  const from = Reflect.get(route.query, 'from') as FaceAuthType;
  // 风控进的人脸
  let info: any = {};
  let req = getToken;
  if ([FaceAuthType.LOGIN].includes(from)) {
    info = {
      phone: Reflect.get(route.query, 'phone') as string,
      from: Reflect.get(route.query, 'from') as string,
      sourceType: 1,
      extendInfo: Reflect.get(route.query, 'extendInfo') as string
    };
    req = getRiskToken;
  } else if ([FaceAuthType.WITHDRAW].includes(from)) {
    if ([FaceAuthType.LOGIN, FaceAuthType.WITHDRAW].includes(from)) {
      info = {
        phone: Reflect.get(route.query, 'phone') as string,
        from: Reflect.get(route.query, 'from') as string,
        sourceType: 7,
        amount: Reflect.get(route.query, 'amount') as string,
        payPassagewayCode: Reflect.get(
          route.query,
          'payPassagewayCode'
        ) as string
      };
      req = getRiskToken;
    }
  } else {
    info = {
      phone: Reflect.get(route.query, 'phone') as string
    };
  }

  const { data: token } = await req({
    returnUrl: `${BASE_DOMAIN}${BASE_PATH}#/face-auth/face-result?${qs.stringify(
      info
    )}`,
    ...info
  });

  //清空history跳转 防止宿主点击返回到agreement页面
  // window.location.href = `https://api.megvii.com/faceid/lite/do?token=${token}`;
  window.history.replaceState(
    null,
    '',
    `${BASE_DOMAIN}/faceid/lite/do?token=${token}`
  );
  window.history.go(0);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})